<template>
  <b-form-group>
    <b-form-input
      required
      class="has-label"
      :ref="refProp"
      v-model="value"
      type="email"
      :tabindex="tabIndexProp"
      :name="name"
      :disabled="disabled"
      :id="inputId"
      :state="isValid"
      :pattern="!isValid"
      @blur.native="handle('blur')"
      @change="handle('change')"
    >
    </b-form-input>
    <label class="custom-input-label" :for="inputId">
      {{ label }}
    </label>
  </b-form-group>
</template>

<script>
export default {
  props: {
    inputId: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      default: '',
    },
    label: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
    refProp: {
      type: String,
      default: 'input',
    },
    tabIndexProp: {
      type: String,
      default: null,
    },
    focus: {
      type: Boolean,
      default: false,
    },
    isValid: {
      type: Boolean,
      default: undefined,
    },
    initialValue: {
      type: String,
    },
  },
  data() {
    return {
      value: '',
    }
  },
  watch: {
    initialValue: {
      handler(value) {
        this.value = value
      },
      immediate: true,
    },
  },
  methods: {
    handle(event) {
      this.$emit('update', { value: this.value, event })
    },
  },
  mounted() {
    if (this.focus) {
      this.$refs[this.refProp].focus()
    }
  },
}
</script>

<style lang="scss" scoped></style>
